import React from "react";

import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import ProjectsCard from "./ProjectsCard";
import projectThree from "../../../assets/projectOne.jpg";
import ecommerceImg from "../../../assets/ecommerce2.jpg";
import ecommerceApp from "../../../assets/ecommerceApp1.png";
import companywebImg from "../../../assets/company-website2.png";
import busSystemImg from "../../../assets/search-bus.PNG";
import projectTwo from "../../../assets/projectTwo.jpg";

const Projects = () => {
  React.useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 700,
      easing: "ease-in-out",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <Navbar />

      <div class="relative flex flex-col-reverse py-16 lg:pt-0 lg:flex-col lg:pb-0">
        <div class="inset-y-0 top-0 right-0 z-0 w-full max-w-xl px-4 mx-auto md:px-0 lg:pr-0 lg:mb-0 lg:mx-0 lg:w-7/12 lg:max-w-full lg:absolute xl:px-0">
          <svg
            class="absolute left-0 hidden h-full text-white transform -translate-x-1/2 lg:block"
            viewBox="0 0 100 100"
            fill="currentColor"
            preserveAspectRatio="none slice"
          >
            <path d="M50 0H100L50 100H0L50 0Z"></path>
          </svg>
          <img
            class="object-cover w-full h-56 rounded shadow-lg lg:rounded-none lg:shadow-none md:h-96 lg:h-full"
            src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&amp;cs=tinysrgb&amp;dpr=2&amp;h=750&amp;w=1260"
            alt=""
          />
        </div>
        <div class="relative flex flex-col items-start w-full max-w-xl px-4 mx-auto md:px-0 lg:px-8 lg:max-w-screen-xl">
          <div class="mb-16 lg:my-40 lg:max-w-lg lg:pr-5">
            <p class="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
              Brand new
            </p>
            <h2 class="mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
              Zemen Digital and
              <br class="hidden md:block" />
              Software Development PLC
            </h2>
            <p class="pr-5 mb-5 text-base text-gray-700 md:text-lg">
              Our journey began with a strong foundation in software development
              and consultancy, we have been working with both local and
              international clients, delivering reliable, scalable, and modern
              digital services.
            </p>
          </div>
        </div>
      </div>
      <section
        id="projects"
        className="w-full py-20 border-b-[1px] border-b-black px-4"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
          <ProjectsCard
            title="bus reservation system"
            des=" it's serve as a crucial online presence, providing information about a business,
           its products or services, and establishing a digital hub for customer interaction."
            src={busSystemImg}
          />
          <ProjectsCard
            title="www.kuku.et, @kuku.et"
            des="Kuku is a digital platform providing seamless market linkages and easy access to inputs, services, and livestock sector."
            src={projectThree}
          />
          <ProjectsCard
            title="E-commerce Website"
            des="Zemen Digital developed a modern e-commerce bookstore, providing a seamless online shopping experience with easy browsing, secure payments."
            src={ecommerceImg}
          />
          <ProjectsCard
            title="ERP Systems"
            des="Scalable ERP solutions that streamline operations, improve business efficiency, and provide real-time insights, helping you make smarter decisions."
            src={projectTwo}
          />

          <ProjectsCard
            title="company website"
            des=" Companys website involves various strategies aimed at increasing its visibility, attracting visitors, and
           achieving specific goals. I made 6 company website."
            src={companywebImg}
          />
          <ProjectsCard
            title="dpms App"
            des=" 
          Developing an kuku app using React Native allows you to create a cross-platform application with a single codebase that runs on both iOS and Android platforms."
            src={ecommerceApp}
          />
        </div>
      </section>

      <Footer />
    </>
  );
};
export default Projects;
